import {ValueObject} from '@s-ui/domain'

/**
 * @export
 * @class NewsDetailRequestValueObject
 * @extends {ValueObject}
 */
export class NewsDetailRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.articleId
   * @param {String} data.locale
   * @param {String} data.slug
   */
}
